/**
 * Slowniki statusow/filtrow i formatowanie dla "Kontrola korekt SFD"
 * (kontrakt: scratchpad/kontrola/KONTRAKT-KOREKTY.md). Kwoty/daty/zakres
 * 1:1 z kontroli faktur - reuzycie, zeby oba moduly liczyly i pokazywaly tak samo.
 * Tylko tokeny kolorow var(--...) z v3sys-theme.css.
 */
export {
  formatujKwote, formatujDate, formatujDateCzas, dataISO, dzisISO, dniWsteczISO,
  domyslnyZakres, OD_DOMYSLNE, OD_CALEJ_HISTORII, SZYBKIE_ZAKRESY,
} from '../kontrola-faktur/format';

/** Ilosc: bez zbednych zer, przecinek polski; null -> '—'. */
export const formatujIlosc = (ilosc) => {
  if (ilosc === null || ilosc === undefined || ilosc === '' || Number.isNaN(Number(ilosc))) return '—';
  return Number(ilosc).toLocaleString('pl-PL', { minimumFractionDigits: 0, maximumFractionDigits: 3 });
};

/** Statusy wiersza kontrola_korekt.status (kontrakt, sekcja Baza). */
export const STATUSY_KOREKT = {
  nowa: { etykieta: 'Bez pozycji', kolor: 'var(--text-secondary)', tlo: 'var(--bg)' },
  gotowa: { etykieta: 'Do dodania', kolor: 'var(--success)', tlo: 'var(--success-light)' },
  brak_faktury: { etykieta: 'Brak faktury źródłowej', kolor: 'var(--danger)', tlo: 'var(--danger-light)' },
  faktura_poza_systemem: { etykieta: 'Faktura poza systemem', kolor: 'var(--warning)', tlo: 'var(--warning-light)' },
  brak_produktow: { etykieta: 'Brak produktów', kolor: 'var(--danger)', tlo: 'var(--danger-light)' },
  dodana: { etykieta: 'Dodana', kolor: 'var(--info)', tlo: 'var(--info-light)' },
  pominieta: { etykieta: 'Pominięta', kolor: 'var(--text-muted)', tlo: 'var(--bg)' },
  blad: { etykieta: 'Błąd', kolor: 'var(--danger)', tlo: 'var(--danger-light)' },
};

/** Chipy filtrow - wartosci `filtr` z kontraktu (GET /kontrola-korekt/lista); `licznik` = klucz w podsumowanie.liczby. */
export const FILTRY_KOREKT = [
  { id: 'do_dodania', etykieta: 'Do dodania', licznik: 'do_dodania', kolor: 'var(--success)' },
  { id: 'brak_faktury', etykieta: 'Brak faktury źródłowej', licznik: 'brak_faktury', kolor: 'var(--danger)' },
  { id: 'faktura_poza_systemem', etykieta: 'Faktura poza systemem', licznik: 'faktura_poza_systemem', kolor: 'var(--warning)' },
  { id: 'brak_produktow', etykieta: 'Brak produktów', licznik: 'brak_produktow', kolor: 'var(--danger)' },
  { id: 'dodane', etykieta: 'Dodane', licznik: 'dodane', kolor: 'var(--info)' },
  { id: 'pominiete', etykieta: 'Pominięte', licznik: 'pominiete', kolor: 'var(--text-secondary)' },
  { id: 'wszystkie', etykieta: 'Wszystkie', licznik: 'wszystkie', kolor: 'var(--primary)' },
];

/** Skad znamy numer faktury korygowanej (kontrola_korekt.faktura_zrodlo) - etykieta odznaki. */
export const ZRODLA_FAKTURY = {
  pdf: 'z PDF',
  xml: 'z XML',
  heurystyka: 'domyślnie: najnowsza pasująca',
  recznie: 'wybrana ręcznie',
};

/** Pewnosc dopasowania faktury korygowanej -> kolor odznaki. */
export const PEWNOSC = {
  wysoka: { etykieta: 'pewność wysoka', kolor: 'var(--success)', tlo: 'var(--success-light)' },
  srednia: { etykieta: 'pewność średnia', kolor: 'var(--warning)', tlo: 'var(--warning-light)' },
  niska: { etykieta: 'pewność niska', kolor: 'var(--danger)', tlo: 'var(--danger-light)' },
};

/** Jedyny status, przy ktorym mozna dodac korekte (POST /dodaj -> 400 dla innych). */
export const STATUS_DO_DODANIA = 'gotowa';

/** Statusy, przy ktorych "Pomiń" ma sens (nie dodana, nie pominieta). */
export const STATUSY_DO_POMINIECIA = new Set(['nowa', 'gotowa', 'brak_faktury', 'faktura_poza_systemem', 'brak_produktow', 'blad']);

/** Komunikat bledu akcji (dodaj/pomin/wybierz) - tresc z backendu ma pierwszenstwo. */
export const komunikatBleduAkcji = (err, domyslny = 'Nie udało się wykonać operacji.') => {
  if (err?.status === 409 || err?.errorCode === 'JUZ_W_SYSTEMIE' || err?.errorCode === 'FAKTURA_ISTNIEJE') {
    return err?.data?.komunikat || err?.message || 'Korekta o tym numerze jest już w systemie — przelicz listę.';
  }
  if (err?.status === 403 || err?.isPermissionError) return 'Ta operacja jest tylko dla administratora.';
  return err?.data?.komunikat || err?.data?.message || err?.message || domyslny;
};
